import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';
import { useCurrentUserRole } from '@/hooks/use-current-user-role';

const ProviderLayoutPage = () => {
  const role = useCurrentUserRole();

  if (role === undefined) {
    return null;
  }

  if (role === 'provider') {
    return <Outlet />;
  }

  if (role === 'operator' || role === 'admin') {
    return <Navigate to='/operators/dashboard' />;
  }

  return <Navigate to='/substitute/dashboard' />;
};

export const Route = createFileRoute('/_protected/provider')({
  loader: async () => {
    const { default: i18n } = await import('../i18n');
    await i18n.loadNamespaces?.(['common', 'dashboard']);
    return null;
  },
  component: ProviderLayoutPage,
});
